const VALUES_SEPARATOR = /,|\n| |\r\n/g

export function parseIds(fileContent: string) {
  return Array.from(
    new Set(
      fileContent
        .split(VALUES_SEPARATOR)
        .map((id) => id.trim())
        .filter((id) => id.length)
    )
  )
}

export function getNewIds(prevValues: string[], newValues: string[]) {
  return newValues.filter((value) => !prevValues.includes(value))
}
